// Every exported cell starts with an uppercase letter. Only the leading character is
// touched: the rest of the value (casing, punctuation, codes) is left exactly as entered.
// Mirrors `capitalizeFirst` in myriad-backend/src/server/utility/export/lib/formatCellValue.js.
export const capitalizeExportValue = (value) => {
  if (typeof value !== 'string' || !value) return value;

  // The first non-space character only. Anything that has no uppercase form — a digit, a
  // symbol, an already-capital letter — is left untouched rather than reaching further
  // into the value, and toLocaleUpperCase keeps accented letters correct ('ñ' -> 'Ñ').
  const index = value.search(/\S/);
  if (index === -1) return value;

  const upper = value[index].toLocaleUpperCase();
  if (upper === value[index]) return value;

  return `${value.slice(0, index)}${upper}${value.slice(index + 1)}`;
};

export default capitalizeExportValue;
